<template>
  <div>
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div :class="{ unfold: unfold }" class="head">
      <div class="tit" @click="fold">{{ cur }}</div>
      <ul>
        <li v-for="item in list" :key="item.id" @click="dtl(item.path)">
          <span v-bind:class="[tenantClassCur(item), tenantClass(item)]">{{
            item.val
          }}</span>
        </li>
      </ul>
    </div>
    <!--child-->
    <router-view />
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      gray: true,
      cur: "Property Details",
      list: [
        {
          path: "/index/property",
          match: "property",
          val: "Property Details",
          id: 0
        },
        {
          path: "/index/plans",
          match: "plans",
          val: "Floor Plans",
          id: 1
        },
        {
          path: "/index/site",
          match: "site",
          val: "Site Plans",
          id: 8
        },
        {
          path: "/index/price",
          match: "price",
          val: "Pricelist",
          id: 2
        },
        {
          path: "/index/specificate",
          match: "specificate",
          val: "Specifications",
          id: 3
        },
        {
          path: "/index/schadule",
          match: "schadule",
          val: "Tax Depreciation Schedule",
          id: 4
        },
        {
          path: "/index/appraisal",
          match: "appraisal",
          val: "Rental Appraisal",
          id: 5
        },
        {
          path: "/index/fee",
          match: "fee",
          val: "Associated Fees",
          id: 6
        },
        {
          path: "/index/looking",
          match: "looking",
          val: "The Why",
          id: 7
        },
        /*{
          path: '/index/pia',
          match: 'pia',
          val: 'PIA',
          id: 8
        },*/
        {
          path: "/index/valuation",
          match: "valuation",
          val: "Comparable Sales",
          id: 9
        }
      ],
      showMask: false,
      pm: {},
      hasPrice: true,
      datum: null,
      unfold: false,
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return;
    }
    that.pm = that.$route.params;
    that.getPropertyDtl({
      params: { id: that.$route.params.id, roomId: that.$route.params.roomId },
      callback: that.callback
    });
    that.list.forEach(v => {
      if (v.match === that.$route.path.split("/")[2]) {
        that.cur = v.val;
      }
    });
  },
  methods: {
    ...mapActions("property", ["getPropertyDtl"]),
    ...mapMutations("login", ["scroll"]),
    // 展开收起
    fold() {
      var that = this;
      that.unfold = !that.unfold;
      that.scroll({ data: that.unfold });
    },
    dtl(path) {
      var that = this;
      if (path !== "/index/pia") {
        if (path === "/index/property") {
          that.$router.push(
            `${path}/${that.pm.id}/${that.pm.roomId}/${that.pm.operate}`
          );
        } else {
          that.$router.push(
            `${path}/${that.pm.id}/${that.pm.roomId}/${that.pm.operate}`
          );
        }
      }
      that.list.forEach(v => {
        if (v.match === that.$route.path.split("/")[2]) {
          that.cur = v.val;
        }
      });
      that.unfold = false;
      that.scroll({ data: that.unfold });
    },
    toPia() {
      var that = this;
      that.$router.push(
        `/index/pia/${that.pm.id}/${that.pm.roomId}/${that.pm.operate}`
      );
    },
    toCus() {
      var that = this;
      that.$router.push({ path: `/pia/selection/${that.pm.id}` });
      that.showMask = false;
    },
    callback(res) {
      var that = this;
      if (res.data.code === 0) {
        that.datum = res.data.data.proertyType;
      } else if (res.data.code === 90000 || res.data.code === 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code === 8902 || res.data.code === 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    tenantClassCur(item) {
      let className = "";
      if (
        this.$route.path.split("/")[2] == item.match ||
        this.current == item.id ||
        (item.id == 8 && this.showMask)
      ) {
        className = "cur";
      }
      return className;
    },
    tenantClass(item) {
      let className = "";
      if (
        this.$route.path.split("/")[2] == item.match ||
        this.current == item.id ||
        (item.id == 8 && this.showMask)
      ) {
        className = "tenant-" + this.tenant;
      }
      return className;
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  position: fixed;
  left: 0;
  top: 1.04rem;
  overflow: hidden;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  .tit {
    height: 1.16rem;
    box-sizing: border-box;
    background: #f5f5f7;
    border-bottom: 1px solid #d0d0d4;
    font-size: 0.32rem;
    text-align: center;
    line-height: 1.16rem;
    color: #3f3f46;
    font-family: ProximaNova-Semibold;
    cursor: pointer;
    position: relative;
  }

  .tit:after {
    content: "";
    display: block;
    width: 0.18rem;
    height: 0.1rem;
    position: absolute;
    right: 0.3rem;
    top: 0.5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url("../../assets/arrw.png");
  }

  ul {
    width: 100%;
    height: 0;
    overflow: hidden;
    background: #f5f5f7;
    transition: all 0.5s;

    li {
      width: 100%;
      text-align: center;
      height: 0.96rem;
      font-size: 0.32rem;
      color: rgba(63, 63, 70, 1);
      line-height: 0.96rem;
    }

    .cur {
      position: relative;
      padding: 0 0.2rem;
    }

    .cur:after {
      content: "";
      display: block;
      width: 100%;
      height: 0.06rem;
      //background: #FFEF00;
      position: absolute;
      left: 0;
      bottom: -0.1rem;
    }
  }
}

.unfold {
  bottom: 0;
  overflow: auto;

  ul {
    height: 10rem;
    transition: all 0.5s;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/details/index.vue